import styled from "@emotion/styled";

export const LeadIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const RowLeadIconDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;
